/**
 * Action types
 */

import { createTypes } from 'reduxsauce'
import { IComponentState, IPaginator } from '../root.types'
import { Patient } from '../../application/models/patient/patient'

export const PatientTypes = createTypes(`

    RESET_CREATE
    RESET_PAGINATOR
   
    LOAD_PATIENT_SUCCESS
    LOAD_PATIENT_FAILURE 
    LOAD_PATIENT_REQUEST
    
    FIND_PATIENT_SUCCESS
    FIND_PATIENT_FAILURE 
    FIND_PATIENT_REQUEST

    CHANGE_PATIENT
    CHANGE_SEARCH
     
    CREATE_PATIENT_SUCCESS
    CREATE_PATIENT_FAILURE 
    CREATE_PATIENT_REQUEST

    UPDATE_PATIENT_REQUEST
    UPDATE_PATIENT_SUCCESS
    UPDATE_PATIENT_FAILURE

    CHANGE_AVATAR_FILE
    CHANGE_AVATAR_IMG
    LOAD_AVATAR_REQUEST
    LOAD_AVATAR_SUCCESS
    LOAD_AVATAR_FAILURE
    REMOVE_AVATAR_REQUEST
    REMOVE_AVATAR_SUCCESS
    REMOVE_AVATAR_FAILURE
`,
    {
        prefix: '@patient/'
    }
)

/**
 * State type
 */
export interface IPatientState {
    readonly list: IListState
    readonly create: ICreateState
}
export interface IListState extends IComponentState {
    readonly patients: Patient[]
    readonly paginator: IPaginator
}
export interface ICreateState extends IComponentState {
    readonly loadingAvatar: boolean
    readonly avatar:IAvatar
    readonly patient: Patient
}
export interface IActionLoadPatient {
    readonly paginator?: IPaginator
}
export interface IActionFind {
    readonly patientId: string
}
export interface IActionUpdate {
    readonly patient: Patient
    readonly avatar?:any
}
export interface IAvatar {
    readonly file?: File
    readonly img?: string
}